export default class ObjectUtils {
  static getTypedKeys<T>(o: T): (keyof T)[] {
    return Object.keys(o) as (keyof T)[];
  }

  /**
   * オブジェクトを文字列に変換します。
   *
   * @param obj 変換対象のオブジェクト
   * @returns オブジェクトの文字列表現
   */
  static objectToStringForLogRegistry<T>(obj: T): string {
    if (!obj) {
      return 'null';
    }
    // オブジェクトのキーと値を文字列に変換して連結
    return Object.entries(obj)
      .map(([key, value]) => `${key}=${value}`)
      .join(', ');
  }
}
